
export default {
  SET_VESSELS(state, data) {
    state.vessels = data;
  },
  SET_PAGING(state, data) {
    state.pageable = data;
  }
}
